module.exports = require("@ember/string");